<template>
  <div class="item-card">
    <div class="card-title">人群包</div>
    <div class="card-content">
      <ul class="modal-form">
        <el-form :disabled="!!alreadyProjectId" :model="curRqbItem" :rules="rules" ref="rqbFormRef">
          <!-- <li class="form-item">
            <span class="form-label" style="padding-top: 6px">人群包：</span>
            <div class="form-value">
              <div class="list-wrap">
                <ul class="data-list">
                  <el-button class="add-btn" icon="el-icon-plus" @click="addRqb">新增人群包</el-button>
                  <li
                    :class="['data-item', item.itemId === curItemId ? 'cur' : '']"
                    v-for="(item, index) of showList"
                    :key="item.itemId"
                    @click="selectRqb(item)"
                  >
                    <span>人群包{{ index + 1 }}</span>
                    <el-dropdown trigger="click" size="small" @command="(type) => handleCommand(item, type)">
                      <i class="el-icon-more dot-icon"></i>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="del" v-show="dataList.length > 1">删除</el-dropdown-item>
                        <el-dropdown-item command="copy">复制</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </li>
                </ul>
                <div class="list-footer">
                  <span class="list-length">{{ dataList.length }}/20</span>
                  <div class="show-more">
                    <span v-show="!showMore" @click="showMore = true">更多<i class="el-icon-arrow-down"></i></span>
                    <span v-show="showMore" @click="showMore = false">收起<i class="el-icon-arrow-up"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </li> -->
          <li class="form-item">
            <span class="form-label" style="padding-top: 10px">自定义：</span>
            <div class="form-value">
              <el-form-item prop="rqbType" style="margin-bottom: 0px">
                <el-radio-group v-model="curRqbItem.rqbType">
                  <el-radio :label="1">不限</el-radio>
                  <el-radio :label="2">自定义</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="table-wrap" v-show="curRqbItem.rqbType === 2">
                <div class="table-item" style="width: 62%; maring-right: 10px">
                  <div class="table-header">
                    <span class="header-text">名称</span>
                    <span class="header-text">属性</span>
                    <span class="header-text">操作</span>
                  </div>
                  <div class="table-content" style="overflow: auto">
                    <div class="item-line" v-for="item of optionList" :key="item.custom_audience_id">
                      <span class="item-col" :title="item.name">{{ item.name }}</span>
                      <span class="item-col" :title="item.tag">{{ item.tag }}</span>
                      <span style="width: 18%; flex-shrink: 0" class="item-col btn-col">
                        <el-button
                          type="text"
                          class="check-btn"
                          :disabled="
                            curRqbItem.data.retargeting_tags_include.find(
                              (dataItem) => dataItem.custom_audience_id === item.custom_audience_id
                            )
                              ? true
                              : false
                          "
                          @click="checkItem(item, 'dx')"
                          >定向</el-button
                        >
                        <el-button
                          type="text"
                          class="check-btn"
                          :disabled="
                            curRqbItem.data.retargeting_tags_exclude.find(
                              (dataItem) => dataItem.custom_audience_id === item.custom_audience_id
                            )
                              ? true
                              : false
                          "
                          @click="checkItem(item, 'pc')"
                          >排除</el-button
                        >
                      </span>
                    </div>
                  </div>
                </div>
                <div class="table-item" style="width: 35%">
                  <div class="table-header">
                    <span class="header-text">已选</span>
                    <span class="header-text" style="color: rgba(24, 144, 255, 1); cursor: pointer" @click="clearAllList">清除</span>
                  </div>
                  <div class="table-content">
                    <ul class="kind-list">
                      <li :class="['kind-item', curShow === 'dx' ? 'cur' : '']" @click="curShow = 'dx'">
                        定向({{ curRqbItem.data.retargeting_tags_include.length }})
                      </li>
                      <li :class="['kind-item', curShow === 'pc' ? 'cur' : '']" @click="curShow = 'pc'">
                        排除({{ curRqbItem.data.retargeting_tags_exclude.length }})
                      </li>
                    </ul>
                    <div class="select-kind-wrap">
                      <div class="data-list" v-show="curShow === 'dx'">
                        <div class="data-item" v-for="item of curRqbItem.data.retargeting_tags_include" :key="item.custom_audience_id">
                          {{ item.name }}<i class="el-icon-close close-btn" @click="deleteItem(item)"></i>
                        </div>
                      </div>
                      <div class="data-list" v-show="curShow === 'pc'">
                        <div class="data-item" v-for="item of curRqbItem.data.retargeting_tags_exclude" :key="item.custom_audience_id">
                          {{ item.name }}<i @click="deleteItem(item)" class="el-icon-close close-btn"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </el-form>
      </ul>
    </div>
  </div>
</template>

<script>
import { getCrowdTag } from "@/api/promotion.js";
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      showMore: true,
      curItemId: "",
      optionList: [],
      curShow: "dx",
      dataList: [],
      rules: {
        rqbType: [
          {
            validator: (rule, value, callback) => {
              let flag = true;
              for (let i = 0; i < this.dataList.length; i++) {
                let item = this.dataList[i];
                if (item.rqbType === 2 && item.data.retargeting_tags_exclude.length + item.data.retargeting_tags_include.length === 0) {
                  flag = false;
                  break;
                }
              }
              flag ? callback() : callback(new Error("自定义人群包不能为空"));
            },
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    this.addRqb();
  },
  methods: {
    addRqb() {
      if (this.dataList.length >= 20) {
        return;
      }
      let randomId = Math.random();
      this.dataList.push({
        itemId: randomId,
        rqbType: 1,
        data: {
          retargeting_tags_include: [],
          retargeting_tags_exclude: [],
        },
      });
      this.curItemId = randomId;
    },
    selectRqb(data) {
      this.curItemId = data.itemId;
    },
    getListOption() {
      getCrowdTag({
        advertiserId: this.adCount,
      }).then((res) => {
        if (res.code === "0000") {
          this.optionList = res.crowdTags;
          this.fillStoreData(); //数据填充完毕后判断是否加载store中的数据
        }
      });
    },
    fillStoreData() {
      if (this.audience) {
        let fillata = this.audience.map((storeItem) => {
          return {
            itemId: Math.random(),
            rqbType: storeItem.retargeting_tags_include.length === 0 && storeItem.retargeting_tags_exclude.length === 0 ? 1 : 2,
            data: {
              retargeting_tags_exclude: storeItem.retargeting_tags_exclude.map((exId) => {
                return this.optionList.find((opItem) => opItem.custom_audience_id == exId);
              }),
              retargeting_tags_include: storeItem.retargeting_tags_include.map((inId) => {
                return this.optionList.find((opItem) => opItem.custom_audience_id == inId);
              }),
            },
          };
        });
        this.curItemId = "";
        this.$set(this, "dataList", fillata);
        this.curItemId = fillata[0].itemId;
      }
    },
    checkItem(dataItem, type) {
      let curItem = this.dataList.find((item) => item.itemId === this.curItemId);
      if (type === "dx") {
        let pcIndex = curItem.data.retargeting_tags_exclude.findIndex((item) => item.custom_audience_id === dataItem.custom_audience_id);
        if (pcIndex !== -1) {
          curItem.data.retargeting_tags_exclude.splice(pcIndex, 1);
        }
        curItem.data.retargeting_tags_include.push(dataItem);
        this.curShow = "dx";
      } else {
        let dxIndex = curItem.data.retargeting_tags_include.findIndex((item) => item.custom_audience_id === dataItem.custom_audience_id);
        if (dxIndex !== -1) {
          curItem.data.retargeting_tags_include.splice(dxIndex, 1);
        }
        curItem.data.retargeting_tags_exclude.push(dataItem);
        this.curShow = "pc";
      }
    },
    clearAllList() {
      let curItem = this.dataList.find((item) => item.itemId === this.curItemId);
      curItem.data.retargeting_tags_include = [];
      curItem.data.retargeting_tags_exclude = [];
    },
    deleteItem(item) {
      let curItem = this.dataList.find((item) => item.itemId === this.curItemId);
      if (this.curShow === "dx") {
        let delIndex = curItem.data.retargeting_tags_include.findIndex(
          (dataItem) => dataItem.custom_audience_id === item.custom_audience_id
        );
        curItem.data.retargeting_tags_include.splice(delIndex, 1);
      } else {
        let delIndex = curItem.data.retargeting_tags_exclude.findIndex(
          (dataItem) => dataItem.custom_audience_id === item.custom_audience_id
        );
        curItem.data.retargeting_tags_exclude.splice(delIndex, 1);
      }
    },
    handleCommand(item, type) {
      if (type === "del") {
        let delIndex = this.dataList.findIndex((dataItem) => dataItem.itemId === item.itemId);
        this.dataList.splice(delIndex, 1);
        this.curItemId = this.dataList[0].itemId;
      } else if (type === "copy") {
        if (this.dataList.length >= 20) {
          return;
        }
        let copyItem = JSON.parse(JSON.stringify(item));
        let itemId = Math.random();
        copyItem.itemId = itemId;
        this.dataList.push(copyItem);
        this.curItemId = itemId;
      }
    },
    saveInStore() {
      let storeData = [];
      this.dataList.forEach((item, index) => {
        storeData.push({
          retargeting_tags_include: item.data.retargeting_tags_include.map((inItem) => inItem.custom_audience_id),
          retargeting_tags_exclude: item.data.retargeting_tags_exclude.map((exItem) => exItem.custom_audience_id),
          audience_name: `人群包${index + 1}`,
        });
      });
      this.$store.commit("set_audience_ttV2", storeData);
    },
    checkData() {
      return new Promise((resolve, reject) => {
        this.$refs.rqbFormRef.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
  },
  computed: {
    curRqbItem() {
      if (this.curItemId) {
        return this.dataList.find((item) => item.itemId === this.curItemId);
      } else {
        return {
          itemId: "",
          rqbType: 1,
          data: {
            retargeting_tags_include: [],
            retargeting_tags_exclude: [],
          },
        };
      }
    },
    showList() {
      if (!this.showMore) {
        return this.dataList.slice(0, 4);
      }
      return this.dataList;
    },
    ...mapState({
      adCount: (state) => state.PromotionTtV2.baseData.advertiser_id,
      audience: (state) => state.PromotionTtV2.audiences,
      alreadyProjectId: (state) => state.PromotionTtV2.baseData.projectId,
    }),
  },
  watch: {
    curRqbItem: {
      handler(val) {
        this.$store.commit("set_current_selected_audience_ttv2", val);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.item-card {
  background-color: #fff;
  padding: 24px;
  margin-bottom: 6px;
  .card-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }
  .card-content {
    margin-top: 20px;
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 20px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 56px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          // padding-top: 6px;
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(0, 0, 0, 0.65);
          }
          .list-wrap {
            .data-list {
              padding: 0px;
              margin: 0px;
              list-style: none;
              .add-btn {
                border-radius: 2px;
                border: 1px solid rgba(24, 144, 255, 1);
                box-sizing: border-box;
                background: rgba(255, 255, 255, 1);
                color: rgba(24, 144, 255, 1);
                margin: 0 14px 12px 0px;
              }
              .data-item {
                display: inline-block;
                border-radius: 2px;
                border: 1px solid rgba(0, 0, 0, 0.15);
                box-sizing: border-box;
                padding: 6px 8px;
                color: rgba(0, 0, 0, 0.85);
                font-size: 14px;
                margin: 0 14px 12px 0px;
                cursor: pointer;
                user-select: none;
                .dot-icon {
                  transform: rotate(90deg);
                  color: #666;
                }
                &.cur {
                  border: 1px solid rgba(24, 144, 255, 1);
                  color: rgba(24, 144, 255, 1);
                  .dot-icon {
                    color: rgba(24, 144, 255, 1);
                  }
                }
              }
            }
            .list-footer {
              display: flex;
              justify-content: space-between;
              .list-length {
                color: rgba(0, 0, 0, 0.85);
                font-size: 14px;
              }
              .show-more {
                color: rgba(24, 144, 255, 1);
                font-size: 13px;
                cursor: pointer;
                margin-left: 20px;
                line-height: 24px;
                i {
                  margin-left: 4px;
                }
              }
            }
          }
          .table-wrap {
            display: flex;
            justify-content: space-between;
            margin-top: 16px;
            .table-item {
              border-radius: 2px;
              border: 1px solid rgba(0, 0, 0, 0.15);
              .table-header {
                display: flex;
                background: rgba(0, 0, 0, 0.02);
                border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                justify-content: space-between;
                .header-text {
                  display: inline-block;
                  width: 33.3%;
                  text-align: center;
                  padding: 12px 0;
                  color: rgba(0, 0, 0, 0.85);
                  font-size: 14px;
                }
              }
              .table-content {
                height: 200px;
                display: flex;
                flex-direction: column;
                .kind-list {
                  padding: 0px;
                  margin: 0px;
                  list-style: none;
                  display: flex;
                  justify-content: space-around;
                  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
                  .kind-item {
                    color: rgba(0, 0, 0, 0.65);
                    font-size: 14px;
                    padding: 12px 0;
                    text-align: center;
                    border-bottom: 2px solid transparent;
                    cursor: pointer;
                    &.cur {
                      color: rgba(24, 144, 255, 1);
                      border-bottom: 2px solid rgba(24, 144, 255, 1);
                    }
                  }
                }
                .select-kind-wrap {
                  height: 100%;
                  overflow: auto;
                  .data-list {
                    .data-item {
                      box-sizing: border-box;
                      padding: 5px 20px 5px 5px;
                      font-size: 12px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      position: relative;
                      .close-btn {
                        position: absolute;
                        right: 5px;
                        top: 8px;
                        cursor: pointer;
                      }
                      &:hover {
                        background-color: #f9f9f9;
                      }
                    }
                  }
                }
                .item-line {
                  display: flex;
                  padding: 5px;
                  &:hover {
                    background-color: #f9f9f9;
                  }
                  .item-col {
                    font-size: 12px;
                    display: inline-block;
                    width: 100%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                  .btn-col {
                    display: flex;
                    justify-content: space-between;
                    .check-btn {
                      cursor: pointer;
                      color: #1890ff;
                      padding: 0px;
                      margin: 0px;
                      font-size: 12px;
                      &:disabled {
                        color: #b1b1b1;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
